// Added by Sejune Oh on 2020-04-21
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    List as MaterialUIList,
    ListProps as MaterialUIListProps
} from '@material-ui/core'

interface ListBaseProps { }
export type ListProps = Partial<MaterialUIListProps> & ListBaseProps

export const List: FC<ListProps> = ({ ...rest }) => {
    return <MaterialUIList {...rest}></MaterialUIList>
}
